module.exports = __webpack_public_path__ + "img/icons_top__Network__white.5e82d097.png";